var acuCustom = ( function( $ ) {
  'use strict';

  var
    firstBanner = $( '.content-for-layout section:first .banner' ),
    headerHeight = $( '.header' ).outerHeight( true ),
    scrollToSection;
  
  scrollToSection = function( target, pixelOffset, duration ) {
    var pixelOffset = pixelOffset;
    if ( !pixelOffset ) {
      pixelOffset = 0;
    }
    // Only prevent default if animation is actually gonna happen
    if ( event != undefined ) {
      //console.log( 'defined: ' + event );
      event.preventDefault();
    }
    var divPosition = $( target ).offset();
    
    if ( divPosition ) {
      $('html, body').animate({
        scrollTop: divPosition.top - pixelOffset
      }, duration, function() {
        
      });
    }

  }; // end scrollToSection


  // if the banner has settings set to "acu_special_banner" via image-banner.liquid theme UI, add a class to body
  if ( $( firstBanner ).attr( 'data-acu-special-collection' ) ) {
    $( 'body' ).addClass( 'acu-special-collection' );
  }


  // partner logos ticker/carousel
  $( '.acu-home-page-v7-partners__logos' ).bxSlider({
    minSlides: 1,
    maxSlides: 20,
    // slideWidth: 150,
    slideMargin: 70,
    ticker: true,
    speed: 15000
  });


  // Select all links with hashes and smooth scroll to them
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
    // On-page links
    if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name="' + this.hash.slice(1) + '"]');
      // Does a scroll target exist?
      if (target.length) {
        scrollToSection( target, headerHeight + 110, 750 );
      }
    }
  });

  if ( $( 'body' ).hasClass( 'acu-page--general-privacy-notice' ) || $( 'body' ).hasClass( 'acu-page--general-privacy-notice' ) ) {
    // add anchor to top of page
    $( 'body' ).attr( 'id', 'top' );
  }





  /* OneTrust Cookie Banner related start */

  $( '.footer-block__details-content a[href="#acu-ot-cookie-preferences-toggle"]' ).on( 'click', function() {
    Optanon.ToggleInfoDisplay();
    return false;
  });

  //console.log( 'Cookies upon load: ', (document.cookie).split(';').join(';\r\n') );
  if ( document.cookie.indexOf( 'OptanonAlertBoxClosed=' ) >= 0 ) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'OnetrustGroupsUpdated',
        'OptanonAlertBoxClosed': 'true'
    });
  }
  else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'OnetrustGroupsUpdated',
        'OptanonAlertBoxClosed': 'false'
    });
  }

  $( function() {
    $( document ).on( 'click', '.save-preference-btn-handler', function () { location.reload(); });
    $(document).on( 'click', '.accept-recommended-btn-handler', function () { location.reload(); });
    $(document).on( 'click', '.acu-video-modal-trigger', OptanonWrapper);
   
  });

  function OptanonWrapper( e2 ) {
    
    window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
    
    var onetrustGroup = $.grep(dataLayer, function (e) { return e.event === 'OneTrustLoaded'; });

    if ( e2.currentTarget.id === 'videoviewbtn' ) {

      if ( onetrustGroup.length > 0 && !onetrustGroup[onetrustGroup.length-1][ 'OnetrustActiveGroups' ].includes( ',C0003,' ) ) {
        
        //console.log( 'OnetrustActiveGroups does *not* include C0003. Video should be visible in US without acceptance of cookies and in EU after allowing functional cookies.' );

        $( '.acu-video-modal-C0003' ).each( function( index, element ){
          
          //console.log( 'video found' );
          
          let dataSrc = $( element ).attr( 'data-src');
          $( element ).attr( 'src', dataSrc );
          
          //console.log( 'src value updated to data-src\'s value' );
          //console.log( 'Cookies after video button click: ', (document.cookie).split(';').join(';\r\n') );
        });
        
      }
      else {
        
        //console.log( 'OnetrustActiveGroups includes C0003. Acceptance of functional cookies is required to see video.' );
        
        $( '.acu-video-modal-C0003' ).each( function( index, element ){ 
          
          //console.log( 'video found' );

          if ( !$( element ).prev( '.acu-cookie-alert' ).length ) {
            $( element ).before( '<div class="acu-cookie-alert"></div>' );
          }

          let elementWrapper = $( element ).prev( '.acu-cookie-alert' );

          $( elementWrapper ).html( '<p class="acu-cookie-alert__video">To enable this video content, please <a href="#" onclick="Optanon.ToggleInfoDisplay();return false;">accept Functional Cookies</a>.</p>' );

          //console.log( 'Cookies after video button click: ', (document.cookie).split(';').join(';\r\n') );

        });
        
      }
    }

  }
  /* OneTrust Cookie Banner related end */


  // Redirection after login

  // if logging in while on collection or product page, redirect the customer to the previous product or collection page after login, else redirect to the account after login.
  var
    currentUrl =  window.location.href,
    searchTerm1 = '/products/',
    searchTerm2 = '/collections/',
    searchTerm3 = '/account',
    searchTermPosition1 = currentUrl.indexOf( searchTerm1 ),
    searchTermPosition2 = currentUrl.indexOf( searchTerm2 ),
    searchTermPosition3 = currentUrl.indexOf( searchTerm3 );

  // if on products or collections pages, store the url in local storage
  if ( searchTermPosition1 > -1 || searchTermPosition2 > -1 ) {
    localStorage.setItem( 'postLoginRedirectUrl', currentUrl );
    //console.log( 'on products or collection page. redirect url: ', localStorage.getItem( 'postLoginRedirectUrl' ) );
  }
  // if not on any account pages, store the home page in local storage
  else if ( searchTermPosition3 === -1 ) {
    localStorage.setItem( 'postLoginRedirectUrl', '/' );
    //console.log( 'not on products or collections page. redirect url: ', localStorage.getItem( 'postLoginRedirectUrl' ) );
  }
  // if on account pages
  else {
    //console.log( 'on accounts page. redirect url: ', localStorage.getItem( 'postLoginRedirectUrl' ) );
  }

  // if on the login page, get the stored previous products or collection url
  if ( $( '#post-login-redirect-url' ).length ) {
    var postLoginRedirectUrl =  localStorage.getItem( 'postLoginRedirectUrl' );
    $( '#post-login-redirect-url' ).val( postLoginRedirectUrl );
    //console.log( 'hidden field detected. postLoginRedirectUrl: ',postLoginRedirectUrl );
  }
  
 

}( jQuery ) );

